<template>
  <div v-if="info">
    <Me />
    <Evaluation :resultName="'evaluationResult'" />
    <ContractCurrent :resultName="'contractCurrentResult'" @emitNext="next" />
    <LoadingSuccess v-if="isLoadingSuccess" />

    <template v-if="isLoadingSuccess">
        <LoansOngoing />
        <SignupProblem :resultName="'signupProblemResult'" @emitNext="next"></SignupProblem>
        <Agreement v-if="signupProblemResult" :resultName="'agreementResult'" @emitNext="next" />
        <!-- <template v-if="contractStatus === 'pending'"> -->
        <template>
          <!-- 본인인증 우선 -->
          <KycMobileWooriCrowd
            v-if="agreementResult"
            :contractStatus="contractStatus"
            :resultName="'kycMobileWooriCrowdResult'"
            @emitNext="next"
          />
          <!-- 상점정보 등록 -->
          <Store 
            v-if="kycMobileWooriCrowdResult" 
            :resultName="'storeResult'" 
            @emitNext="next" 
          />
          <!-- 여신협회계정 -->
          <SalesAccount v-if="storeResult" :resultName="'salesAccountResult'" @emitNext="next" />
          <!-- <SalesAccount v-if="storeResult" :resultName="'salesAccountResult'" @emitNext="gotoSalesPage" /> -->
        </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    Me: () => import('./Me.vue'),
    // KycMobile: () => import('./kycMob/ile.vue'),
    SignupProblem: () => import('./SignupProblem.vue'),
    Store: () => import('./Store.vue'),
    SalesAccount: () => import('./SalesAccount.vue'),
    LoansOngoing: () => import('./LoansOngoing.vue'),
    Evaluation: () => import('./Evaluation.vue'),
    ContractCurrent: () => import('./ContractCurrent.vue'),
    LoadingSuccess: () => import('./LoadingSuccess.vue'),
    Agreement: () => import('./steps/pending/Agreement.vue'),
    // GuideReadyService: () => import('./steps/completed/GuideReadyService.vue'),
    KycMobileWooriCrowd: () => import('./KycMobileWooriCrowd.vue'),
    // StatusLoading: () => import('./StatusLoading.vue'),
  },
  data() {
    return {
      agreementResult: false,
      contractCurrentResult: false,
      contractDocumentsResult: false,
      collectionAccountResult: false,
      withdrawalAccountResult: false,
      certifyIncomeResult: false,
      contractLimitTransactionResult: false,
      kycMobileResult: false,
      salesAccountResult: false,
      factoringConfirmResult: false,
      idCardResult: false,
      signupDocumentsResult: false,
      completeLimitTransactionResult: false,
      applyBeforeResult: false,
      guideReadyServiceResult: false,
      storeResult: false,
      factoringSuccessResult: false,
      statusLoadingResult: false,
      kycMobileWooriCrowdResult: false,
      kycMobileDefault: false,
      bankCollectionsResult: false,
      signupProblemResult: false,
    }
  },
  computed: {
    ...mapState('auth', ['info', 'me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
    ...mapState('contract', { contractCurrent: 'current' }),
    ...mapGetters('myfinbiz', ['platformCode']),

    isSignupManage() {
      return this.$cookies.get('signupManage') === 'manage'
    },
    isLoadingSuccess() {
      return this.info && this.me
    },
    contractStatus() {
      return this.contractCurrent?.status || ''
    },
    isBuynowWooriCrowd() {
      console.log('PLATFORM CODE ', this.platformCode)
      return this.platformCode === 'buynow-woori-crowd'
    },
  },
  methods: {
    ...mapActions('auth', ['updateMe']),
    ...mapActions('contract', ['getCurrent']),
    next({ name, result }) {
      this[name] = result

      console.log('NAME', name)
      console.log('RESULT', result)
    },
    async gotoSalesPage(){
      console.log('GOTO SALES PAGE')
      await this.$router.push('/sales')
    },
  },
  async created() {
    if (!this.contractCurrent) {
      await this.getCurrent()
    }
  }
}
</script>
